import React from 'react';
import Animated, { Extrapolation, interpolate, useAnimatedStyle } from 'react-native-reanimated';

import { EventInfo } from '@/api/events/types/types';
import { Box } from '@/components/lib/components';
import { Handle, MODAL_HANDLE_HEIGHT } from '@/feature/alerts/components/Modal';
import { CircularPagerSheetHandleGestureWrapper } from '@/feature/circular-pager/BottomSheetCircularPagerWrapper';
import { useScrollableModalContext } from '@/feature/circular-pager/ScrollableModalContextProvider';
import { EVENT_HEADER_HERO_IMAGE_HEIGHT } from '@/feature/lobby/components/EventHeader';
import { MaxWidthWrapper } from '@/feature/responsive-design/WebComponents';
import { common, designSystem, withOpacity } from '@/styles/styles';
import { League } from '@/types/api.generated';

import { useSinglePlayerProfile } from '../SinglePlayerProfileProvider';
import { EVENT_SHEET_TITLE_HEIGHT, EventSheetTitle } from './EventSheetTitle';

// TODO: manage UFC header if dedicated event not set -> easier to do in the PR with UFC fights tabs
export const EventDetailsSheetHandle = ({
    eventDedicatedHeaderInfo,
    eventInfo,
}: {
    eventInfo: EventInfo | null;
    eventDedicatedHeaderInfo: EventInfo | null;
}) => {
    // we cannot compute shouldFreeze above and passed it down as props because it would flicker the modal
    // when we swipe through the tabs
    // so we will compute "shouldFreeze" here again using animated values
    const { playerProfileAnimatedIndex } = useSinglePlayerProfile();

    const { scrollOffset } = useScrollableModalContext();

    const backgroundStyle = useAnimatedStyle(() => {
        if (!eventDedicatedHeaderInfo) {
            return {
                backgroundColor: designSystem.colors.gray8,
            };
        }
        return {
            backgroundColor:
                scrollOffset.value > EVENT_HEADER_HERO_IMAGE_HEIGHT - MODAL_HANDLE_HEIGHT - EVENT_SHEET_TITLE_HEIGHT
                    ? designSystem.colors.gray8
                    : 'transparent',
        };
    });

    const handleStyle = useAnimatedStyle(() => ({
        opacity: interpolate(playerProfileAnimatedIndex.value, [-1, 0], [1, 0], Extrapolation.CLAMP),
    }));

    if (!eventInfo) {
        return null;
    }

    return (
        <CircularPagerSheetHandleGestureWrapper>
            <Box
                position={'absolute'}
                zIndex={1}
                width={'100%'}
                height={EVENT_SHEET_TITLE_HEIGHT + MODAL_HANDLE_HEIGHT}
                overflow={'hidden'}
                borderTopLeftRadius={'r16'}
                borderTopRightRadius={'r16'}
            >
                <MaxWidthWrapper>
                    <Animated.View style={[common.flex, backgroundStyle]}>
                        <Animated.View style={handleStyle}>
                            <Handle
                                handleColor={withOpacity(designSystem.colors.white, 0.15)}
                                handleContainerStyle={common.backgroundColorTransparent}
                            />
                        </Animated.View>
                        <EventSheetTitle
                            event={eventInfo}
                            isOnlyDedicatedHeader={eventDedicatedHeaderInfo !== null || eventInfo.league === League.Ufc}
                            scrollOffset={scrollOffset}
                        />
                    </Animated.View>
                </MaxWidthWrapper>
            </Box>
        </CircularPagerSheetHandleGestureWrapper>
    );
};
